import * as Types from "../actions/action.types"
import * as Models from "../models/index"
export const defaultState = {
    phase: 1,
    questions: [] as Models.Question[],
    username: "",
    isQuestionsLoaded: false,
    allowReset: null as boolean,
    answers: {} as { [id: string]: Models.Answer },
    reseted: null as boolean
}
export type ReducerState = typeof defaultState;
export function reducer(state = defaultState, action: any): ReducerState {
    switch (action.type) {
        case Types.CHANGE_LOGIN_USERNAME: {
            let payload = action.payload as Types.CHANGE_LOGIN_USERNAME_PAYLOAD;
            return {
                ...state,
                username: payload
            }
        }
        case Types.PWD_RECOVERY_START:
            return {
                ...defaultState,
                username: state.username
            }
        case Types.PWD_RECOVERY_GO_TO_QUESTIONS:
            return {
                ...state,
                phase: 2
            }
        case Types.PWD_RECOVERY_CHECK_ANSWERS:
            return {
                ...state,
                phase: action.payload ? 3 : 1,
                allowReset: action.payload
            }
        case Types.PWD_RECOVERY_SET_USERNAME:
            return {
                ...state,
                username: action.payload
            }
        case Types.PWD_RECOVERY_SET_QUESTIONS: {
            let qPayload = action.payload as Models.Question[];
            let answers = {} as { [id: string]: Models.Answer };
            qPayload.forEach(q => {
                answers = {
                    ...answers,
                    [q.questionId]: {
                        questionId: q.questionId,
                        answer: ""
                    }
                }
            })
            return {
                ...state,
                questions: qPayload,
                isQuestionsLoaded: true,
                answers: answers
            }
        }
        case Types.PWD_RECOVERY_PENDING:
            return {
                ...state,
                isQuestionsLoaded: false
            }
        case Types.PWD_RECOVERY_UPDATE_ANSWER: {
            let payload = action.payload as Models.Answer;
            return {
                ...state,
                answers: {
                    ...state.answers,
                    [payload.questionId]: payload
                }
            }
        }
        case Types.PWD_RECOVERY_RESET: {
            return {
                ...state,
                reseted: action.payload
            }
        }
        default:
            return state;
    }
}